import { api } from './api';

export type QueueKind = 'contribution' | 'build-hint' | 'deliverable' | 'ask' | 'router-prompt' | 'register-proposal' | 'slide-brief';

export interface SlideBrief {
  title: string;
  why: string;
  slideType: string;
  screen: 'left' | 'right' | 'pair';
  when: 'now' | 'next-break' | 'wrap-up';
  points: Array<{ text: string; evidenceSeq: number[] }>;
}
export type R1aMode = 'off' | 'shadow' | 'live';

export interface QueueEntry {
  kind: QueueKind;
  ref: string;
  summary: string;
  answers: string[];
  createdAt: string;
  question?: string;
  default?: string;
  expiresAt?: string;
  shadow?: boolean;
  goalId?: string;
  state?: string;
  answer?: string;
  answeredVia?: string;
  wouldDefault?: string;
  onGlasses?: boolean;
  source?: string;
  brief?: SlideBrief;
}

export interface QueueView {
  sessionId: string;
  mode: R1aMode;
  items: QueueEntry[];
}

export const queueService = {
  /** Entries come back oldest first. */
  async list(sessionId: string): Promise<QueueView> {
    const res = await api.get(`/api/sessions/${sessionId}/approval-queue`);
    return res.data;
  },

  async answer(sessionId: string, entry: Pick<QueueEntry, 'kind' | 'ref'>, answer: string, text?: string) {
    const res = await api.post(
      `/api/sessions/${sessionId}/approval-queue/${entry.kind}/${encodeURIComponent(entry.ref)}/answer`,
      { answer, ...(text !== undefined ? { text } : {}) }
    );
    return res.data;
  },
};
